// extracted by mini-css-extract-plugin
export var cardLayout = "_9h-1";
export var paginationContainer = "_9h-0";